import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import { useTheme } from "@material-ui/styles";
import { createTheme, styled } from "@mui/material/styles";
import { position } from "stylis";
import TabScrollButton from "@material-ui/core/TabScrollButton";
import { withStyles } from "@material-ui/core/styles";
import { Badge } from "@mui/material";
import MailIcon from '@mui/icons-material/Mail';
import { find } from "lodash";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  childHeight?: string;
}

function _TabPanel({ children, value, index, childHeight, ...other }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: 0,
            backgroundColor: "#FFFFFF",
            borderTop: "1px solid #C1C7CB",
            borderLeft: "1px solid #C1C7CB",
            borderRight: "1px solid #C1C7CB",
            borderBottom: "1px solid #C1C7CB",
          }}

          className="visible-print "
        >
          <div className="tabsScroll" style={{ height: childHeight ? childHeight : '70vh' }} id="scrollableDiv" >
            <div style={{ direction: "rtl", marginLeft: "3vh" }}>
              <Typography>{children}</Typography>
            </div>
          </div>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface tabsInterface {
  tab: any;
  onChange?: any,
  colorTab: string;
  childHeight?: string;
  currentTabNumber: number;
}

export default function TabPanelCmp({ tab, colorTab, childHeight, currentTabNumber, onChange }: tabsInterface) {
  let activeTab: number = 0;

  const [value, setValue] = React.useState(currentTabNumber);
  const { customerNationalCode, loanRequestId } = useParams<any>();

  //useEffects
  React.useEffect(() => {
    // if (currentTabNumber !== value)
    setValue(currentTabNumber);
  }, [currentTabNumber]);

  //Event Handlers
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    onChange(newValue);
    setValue(newValue);
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#1d4a87 !important",
      background: "#FFFFFF !important",
      alignItems: "center",
      borderRight: "2px solid #C1C7CB",
      borderLeft: "2px solid #C1C7CB !important",
      borderBottom: "2px solid white !important",
      boxShadow: "0 4px 0 -2px white !important",
      fontWeight: "bold",
      height: "50px !important",
      minHeight: "50px !important",
      top: "0px !important"
    },
    "&.MuiSvgIcon-root": {
      width: "24px",
      height: "24px",
    },
    "&.MuiTab-root": {
      // background: "#ECEFF1 !important",
      color: "#1d4a87 !important",
    },
  });

  const MyTabScrollButton = withStyles((theme) => ({
    root: {
      width: 28,
      overflow: "hidden",
      transition: "width 0.5s",
      direction: "rtl",

      "&.Mui-disabled": {
        width: 0,
      },
    },
  }))(TabScrollButton);

  // , borderBottom: "1px solid #C1C7CB"
  return (
    <Box sx={{ margin: "1.9vh", direction: "rtl", overflowX: "auto", paddingBottom: '2vh' }}>
      <Box style={{ overflowX: "auto" }}>
        {/* */}
        <Tabs
          variant="scrollable"
          scrollButtons={false}
          ScrollButtonComponent={MyTabScrollButton}
          allowScrollButtonsMobile
          value={value}
          onChange={handleChange}
          style={{ overflowX: "auto", width: "max-content" }}
          TabIndicatorProps={{
            style: {
              background: colorTab,
              top: 0,
              height: "4px ",
            },
          }}
        >
          {tab.map((item: any) => (
            //
            <StyledTab
              label={<><div><Badge anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }} color="success"
                badgeContent={item.totalFoundCount + ""}>
                <div style={{ marginRight: "18px" }}>{item.title}</div>
              </Badge></div>
              </>}
              icon={item.icon}
              {...tabProps(0)}
              key={item.id}
              style={{
                borderLeft: "2px solid white",
                height: "45px",
                minHeight: "45px",
                alignItems: "center",
                background: "#F6F8F9",
                flexDirection: "row",
                padding: "20px",
                fontSize: "13px",
                backgroundColor: "#ECEFF1",
                top: "10px",
                borderTopLeftRadius: "5px",
                borderTopRightRadius: "5px"
                // fontWeight: "bold",
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tab.map((item: any) => (
        <_TabPanel value={value} index={item.id} key={item.id} childHeight={childHeight} >
          {item.child}
        </_TabPanel>
      ))}
    </Box>
  );
}
